/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentType } from './agentType';
import { SensitivityLevel } from './sensitivityLevel';
import { TrainingTimeWindow } from './trainingTimeWindow';
import { TrainingFrequency } from './trainingFrequency';


export interface AnomalyDetectionOrganizationSettingModel { 
    id?: string | null;
    organizationId?: number;
    organizationMnemonic?: string | null;
    trainingFrequency?: TrainingFrequency;
    trainingTimeWindow?: TrainingTimeWindow;
    sensitivityLevel?: SensitivityLevel;
    agent?: AgentType;
    featureWeights?: { [key: string]: any; } | null;
    createdAt?: string;
    updatedAt?: string | null;
}

